export default function GridFinderLogo(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 171 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1066_1348)">
        <path
          d="M0 0.5L31.682 8.84448L63.3641 0.5V34.1555L31.682 42.5L0 34.1555V0.5Z"
          fill="#0C0C0C"
        />
        <path
          d="M12.4984 16.0622V25.166L24.4072 28.3013V27.0031L13.8189 24.2189V17.7115L31.026 22.243V36.5478L5.87965 29.9261V7.82388L31.026 14.4456V20.9448L12.4984 16.0622Z"
          fill="white"
        />
        <path
          d="M38.9652 19.2057V20.5039L57.4927 15.6213V22.1287L38.9652 27.0113V34.8169L32.3464 36.5642V14.4537L57.4927 7.83204V14.3313L38.9652 19.2057Z"
          fill="white"
        />
        <path
          d="M1.32874 33.2002L10.8624 35.715V32.5389L4.55092 30.8814V6.16641L10.8624 7.83204V4.66407L1.32874 2.1493V33.2002Z"
          fill="url(#paint0_linear_1066_1348)"
        />
        <path
          d="M12.1828 32.89V36.0579L31.682 41.1936L51.1314 36.0743V32.9063L31.682 38.0257L12.1828 32.89Z"
          fill="url(#paint1_linear_1066_1348)"
        />
        <path
          d="M12.1828 5.007V8.18312L31.682 13.3107V13.3188L51.1314 8.19129V5.02333L31.682 10.1427L12.1828 5.007Z"
          fill="url(#paint2_linear_1066_1348)"
        />
        <path
          d="M52.4518 4.67224V7.84837L58.8132 6.16641V30.8814L52.4518 32.5552V35.7232L62.0353 33.2002V2.1493L52.4518 4.67224Z"
          fill="url(#paint3_linear_1066_1348)"
        />
        <path
          d="M65.8555 0.5V16.103H84.9062V6.01128H71.8763V10.5999H79.8985V11.5226H70.8714V5.09681H84.9062V0.5H65.8555Z"
          fill="inherit"
        />
        <path
          d="M127.883 0.5H112.004V16.103H127.883L131.055 12.9841V3.61897L127.883 0.5ZM126.039 9.9549L124.453 11.5144H117.02V5.08865H124.453L126.039 6.64813V9.96306V9.9549Z"
          fill="inherit"
        />
        <path d="M111.074 0.5H106.058V16.103H111.074V0.5Z" fill="inherit" />
        <path
          d="M105.925 18.5525V27.6563L96.6655 18.5525H91.6579V34.1555H96.6738V25.0517L105.925 34.1392V34.1555H110.941V18.5525H105.925Z"
          fill="inherit"
        />
        <path
          d="M131.728 18.5525V34.1555H150.778V29.5669H136.744V28.6524H150.778V24.0638H136.744V23.1493H150.778V18.5607H131.728V18.5525Z"
          fill="inherit"
        />
        <path
          d="M116.754 23.1411H124.195L125.781 24.7006V28.0074L124.195 29.5669H116.754V23.1411ZM111.747 18.5525V34.1555H127.625L130.797 31.0366V21.6715L127.625 18.5525H111.747Z"
          fill="inherit"
        />
        <path
          d="M65.8555 18.5525V34.1555H70.8714V28.6442H84.9145V24.0556H70.8714V23.1411H84.9145V18.5525H65.8638H65.8555Z"
          fill="inherit"
        />
        <path
          d="M90.8606 18.5525H85.8446V34.1555H90.8606V18.5525Z"
          fill="inherit"
        />
        <path
          d="M156.733 23.1411H165.76V24.0638H156.733V23.1411ZM151.717 18.5607V34.1474H156.733V28.6851H162.363L165.984 32.4082V34.1555H171V31.1182L168.492 28.4973L171 26.4234V22.0226L167.429 18.577H151.717V18.5607Z"
          fill="inherit"
        />
        <path
          d="M90.8523 5.08871H99.8794V6.01134H90.8523V5.08871ZM85.8446 0.508232V16.0949H90.8606V10.6326H96.4911L100.112 14.3558V16.1031H105.128V13.0658L102.62 10.4449L105.128 8.37098V3.97013L101.557 0.508232H85.8446Z"
          fill="inherit"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1066_1348"
          x1="6.09557"
          y1="2.1493"
          x2="6.09557"
          y2="35.715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1066_1348"
          x1="31.6571"
          y1="32.89"
          x2="31.6571"
          y2="41.1936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1066_1348"
          x1="31.6571"
          y1="5.007"
          x2="31.6571"
          y2="13.3188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1066_1348"
          x1="57.2436"
          y1="2.1493"
          x2="57.2436"
          y2="35.7232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6100" />
          <stop offset="0.495407" stopColor="#FF4F00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
        <clipPath id="clip0_1066_1348">
          <rect
            width="171"
            height="42"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
